import semver from 'semver';

const sessionCouldHaveScoringData = function(sessionContentsOrVersion, schemaRef) {
    if (!semver.valid(sessionContentsOrVersion)) {
        return false;
    }

    return semver.gte(sessionContentsOrVersion, '1.7.0');
};

export default sessionCouldHaveScoringData;